export default "__VITE_ASSET__C4ESZQUW__"